<!--  -->
<template>
  <div class="e-shop-title">
    <div class="title">{{ title }}</div>
    <div class="title-en">{{ titleEn }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    titleEn: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.e-shop-title {
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
  .title-en {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    text-align: center;
  }
}
</style>
